import { render, staticRenderFns } from "./CrmAccountDetail.vue?vue&type=template&id=4ecd15be&scoped=true&"
import script from "./CrmAccountDetail.vue?vue&type=script&lang=js&"
export * from "./CrmAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./styles/CrmAccountDetail.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./CrmAccountDetail.vue?vue&type=style&index=1&id=4ecd15be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd15be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecd15be')) {
      api.createRecord('4ecd15be', component.options)
    } else {
      api.reload('4ecd15be', component.options)
    }
    module.hot.accept("./CrmAccountDetail.vue?vue&type=template&id=4ecd15be&scoped=true&", function () {
      api.rerender('4ecd15be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/components/CrmAccountDetail.vue"
export default component.exports